namespace RioERP.Orders {
    export interface OrdersExcelImportForm {
        FileName: Serenity.ImageUploadEditor;
    }

    export class OrdersExcelImportForm extends Serenity.PrefixedContext {
        static formKey = 'RioERP.OrdersExcelImportForm';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!OrdersExcelImportForm.init)  {
                OrdersExcelImportForm.init = true;

                var s = Serenity;
                var w0 = s.ImageUploadEditor;

                Q.initFormType(OrdersExcelImportForm, [
                    'FileName', w0
                ]);
            }
        }
    }
}
